
import VSwatches from 'vue-swatches';
import {editor} from './editor';
import 'vue-swatches/dist/vue-swatches.css';

export default editor.extend({
  mixins:[editor],
  components: { VSwatches },
  async mounted() {
    const isSingle = (this as any).colorSelectMode === 'single';
    const _result = await this.validateValueType(this.valueTypes.string, isSingle);
    if (!_result?.isInvalid) return;
    this.valueTypeError = _result;
  },
  data() {
    return {
      valueTypeError: null,
    };
  },
  computed: {
    /** Разбор поля ProductClassParam.editor: "color" или JSON {"name":"color","mode":"single|multiple"}. */
    colorSelectMode() {
      const raw = (this as any).param?.editor;
      if (raw == null || raw === '') return 'multiple';
      if (typeof raw === 'string') {
        const s = raw.trim();
        if (s.startsWith('{')) {
          try {
            const p = JSON.parse(s);
            const m = p.mode;
            if (m === 'single' || m === 'multiple') return m;
            return 'multiple';
          } catch {
            return 'multiple';
          }
        }
        return 'multiple';
      }
      return 'multiple';
    },
    mode() {
      return (this as any).colorSelectMode;
    },
    productParam() {
      if (!this.isDefined) return null;
      return this.productParamDataSource.items.find((p:any) => p.productClassParamId === this.productClassParamId);
    },
    productParams() {
      if (!this.isDefined) return [];
      return this.productParamDataSource.items.filter((p:any) => p.productClassParamId === this.productClassParamId);
    },
    editorValue() {
      return this.productParam?.value ?? null;
    },
  },
  methods: {
    isInclude(value) {

      if (!((this as any).productParams?.length > 0)) return false;
      return (this as any).productParams.some((p:any) => p.value == value);
    },
    isSelected(label) {
      return label === (this as any).editorValue;
    },
    async selectColor(item: { id: number; value: string; caption: string }) {
      if (!item) throw new Error('Элемент не найден');
      if ((this as any).colorSelectMode === 'single') {
        if (this.productParam?.id) {
          await this.updateProductParam(
            item.id,
            item.value,
            item.caption,
            this.productParam.id,
            item.caption,
            '',
          );
        } else {
          await this.addProductParam(
            item.id,
            item.value,
            item.caption,
            this.valueTypes.string,
            item.caption,
            '',
          );
        }
        return;
      }
      if ((this as any).isInclude(item.value)) {
        const row = (this as any).productParams.find(
          (p: { id: number; value: string }) => p.value == item.value,
        );
        await this.deleteProductParam(row.id);
      } else {
        await this.addProductParam(
          item.id,
          item.value,
          item.caption,
          this.valueTypes.string,
          item.caption,
          '',
        );
      }
    },
  },
});
